import * as LDClient from 'launchdarkly-js-client-sdk'

const anonymousContext = {
  kind: 'multi',
  user: {
    kind: 'user',
    anonymous: true
  },
  parent_company: {
    kind: 'parent_company',
    anonymous: true
  }
}

let client

export function initLaunchDarkly () {
  if (client) {
    return
  }

  client = LDClient.initialize(
    process.env.VUE_APP_LAUNCH_DARKLY_CLIENT_ID,
    anonymousContext,
    {
      logger: LDClient.basicLogger({ level: 'none' })
    }
  )
}

export function identify (data) {
  client.identify({
    kind: 'multi',
    user: {
      key: data.company_id,
      kind: 'user'
    },
    parent_company: {
      key: data.parent_id,
      kind: 'parent_company'
    }
  })
}

export function anonymise () {
  client.identify(anonymousContext)
}

export function onFlagChange (flag, cb) {
  client.on(`change:${flag}`, (newValue, oldValue) => {
    cb(newValue, oldValue)
  })
}

export function onFlagStateChange (cb) {
  const listener = () => {
    cb(client.allFlags())
  }

  client.on('ready', listener)
  client.on('change', listener)
}
